var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Editor',{staticClass:"singleLineEditor",style:(_vm.editorStyle),attrs:{"api-key":_vm.TINY_MCE,"init":_vm.editorOptions},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }